// Attendre que tout soit chargé
window.addEventListener('load', function() {
  setTimeout(function() {
    const variantInputs = document.querySelectorAll('input[type="radio"][form*="product-form"]');
    
    console.log('Nombre de variantes trouvées:', variantInputs.length);
    
    variantInputs.forEach(function(input) {
      input.addEventListener('click', function() {
        console.log('Clic sur:', this.value);
        // Décocher puis recocher pour forcer le changement
        this.checked = false;
        setTimeout(() => {
          this.checked = true;
          this.dispatchEvent(new Event('change', { bubbles: true }));
        }, 10);
      });
    });
  }, 500);
});
